import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const ConfirmContent = styled(FlexBox)`
    position: fixed;
  z-index: 999999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 560px;
  max-width: 560px;
  max-height: 346px;
  background-color: #fefefe;
  padding: 32px 40px 40px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.20);
  border-radius: 8px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    button {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }
  }
   @media (max-width: ${LayoutConst.screen.s}px) {
    width: 300px;
    max-width: 300px;
    padding: 16px;
    max-height: 500px;
  }
`;

export const ConfirmButton = styled(ExploreButtonHollow)`
    max-width: 228px;
    width: 228px;
    min-width: 228px !important;
    height: 48px;
    @media (max-width: ${LayoutConst.container.s}px) {
    max-width: 300px;
    width: 100%;
    min-width: 228px !important;
  }
`;

export const DeclineButton = styled(ExploreButtonFilled)`
    max-width: 228px;
    width: 228px;
    min-width: 228px !important;
    height: 48px;
    @media (max-width: ${LayoutConst.container.s}px) {
    max-width: 300px;
    width: 100%;
    min-width: 228px !important;
  }
`;

export const ConfirmText = styled.div`
    font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.56px;
  color: #151514;
  @media (max-width: ${LayoutConst.container.l}px) {
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
  }
  @media (max-width: ${LayoutConst.container.m}px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const CloseWrapper = styled.div`
    position: absolute;
    top: 24px;
    right: 26px;
    cursor: pointer;

    &:hover {
        svg path {
          fill: ${(p) => p.theme.modal.closeColor};
        }
      }

`;import { FlexBox } from "@brg/ui";
import { LayoutConst } from "core";
import { ExploreButtonFilled, ExploreButtonHollow } from "shared/pages/explore/styles";
import styled from "styled-components";

export const ConfirmWrapper = styled.div`
  position: absolute;
  z-index: 999999;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;

export const ConfirmContent = styled(FlexBox)`
    position: fixed;
  z-index: 999999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 560px;
  max-width: 560px;
  max-height: 346px;
  background-color: #fefefe;
  padding: 32px 40px 40px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.20);
  border-radius: 8px;

  @media (max-width: ${LayoutConst.screen.m}px) {
    button {
      width: 100%;
      min-width: 100%;
      max-width: 100%;
    }
  }
   @media (max-width: ${LayoutConst.screen.s}px) {
    width: 300px;
    max-width: 300px;
    padding: 16px;
    max-height: 500px;
  }
`;

export const ConfirmButton = styled(ExploreButtonHollow)`
    max-width: 228px;
    width: 228px;
    min-width: 228px !important;
    height: 48px;
    @media (max-width: ${LayoutConst.container.s}px) {
    max-width: 300px;
    width: 100%;
    min-width: 228px !important;
  }
`;

export const DeclineButton = styled(ExploreButtonFilled)`
    max-width: 228px;
    width: 228px;
    min-width: 228px !important;
    height: 48px;
    @media (max-width: ${LayoutConst.container.s}px) {
    max-width: 300px;
    width: 100%;
    min-width: 228px !important;
  }
`;

export const ConfirmText = styled.div`
    font-size: 28px;
  font-style: normal;
  font-weight: 600;
  line-height: 34px;
  letter-spacing: -0.56px;
  color: #151514;
  @media (max-width: ${LayoutConst.container.l}px) {
    font-size: 26px;
    line-height: 32px;
    font-weight: 600;
  }
  @media (max-width: ${LayoutConst.container.m}px) {
    font-size: 24px;
    line-height: 28px;
  }
`;

export const CloseWrapper = styled.div`
    position: absolute;
    top: 24px;
    right: 26px;
    cursor: pointer;

    &:hover {
        svg path {
          fill: ${(p) => p.theme.modal.closeColor};
        }
      }

`;